export default "__VITE_ASSET__CDy1Lp92__"